import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/warmInboundTracker';

/**
 * Listens to route changes and reports pageviews to the Warm Inbound Watch
 * edge function. Mount once inside the Layout. SSG-safe.
 */
const WarmInboundTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Defer to next tick so the document title (set by Helmet via vite-react-ssg
    // Head) has a chance to update before we snapshot it.
    const id = window.setTimeout(() => {
      trackPageView(location.pathname, document.title);
    }, 50);
    return () => window.clearTimeout(id);
  }, [location.pathname]);

  return null;
};

export default WarmInboundTracker;
